export default __webpack_public_path__ + "static/rasmalai-df0a9d0d451fa6ca60348b51a7502ef9.png";